<template>
  <div>
    <div class="card card-custom gutter-b" v-if="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="text-center">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
        </div>
      </div>
    </div>
    <!--begin::Dashboard-->
    
  <div class="card card-custom gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">{{ $t('ECOMMERCE.ORDER_OVERVIEW') }}</span>
      </h3>
    </div>

    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-head-custom table-vertical-center">
            <thead>
                <tr>
                    <th style="min-width: 60px">{{ $t('ECOMMERCE.ORDER') }}</th>
                    <th style="min-width: 120px">{{ $t('ECOMMERCE.USER') }}</th>
                    <th style="min-width: 140px" class="text-center">{{ $t('ECOMMERCE.DATE') }}</th>
                    <th style="min-width: 80px; max-width: 120px" class="text-center">{{ $t('TRANSLATOR.STATUS') }}</th>
                    <th style="min-width: 100px; max-width: 120px" class="text-right">{{ $t('ECOMMERCE.TOTAL_PRICE') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody v-if="this.list.length >= 1">
              <template v-for="(item, i) in list">
                <tr v-bind:key="i">
                    <td class="align-items-center font-weight-bolder">
                        #{{  item.id }}
                    </td>
                    <td>
                        {{ item.userName}}
                        <span class="text-muted">
                          "{{ item.note}}"
                        </span>
                        
                    </td>
                    <td class="text-center align-middle">
                        {{ item.date }}
                    </td>
                    <td class="text-center align-middle">
                      <span v-if="item.status === 0" class="label label-lg label-light-primary label-inline"> {{ $t('ECOMMERCE.IN_PROGRESS') }}</span>
                      <span v-if="item.status === 1" class="label label-lg label-light-success label-inline"> {{ $t('ECOMMERCE.APPROVED') }}</span>
                      <span v-if="item.status === 2" class="label label-lg label-light-success label-inline"> {{ $t('ECOMMERCE.COMPLETED') }}</span>
                      <span v-if="item.status === 3" class="label label-lg label-light-danger label-inline"> {{ $t('ECOMMERCE.CANCELED') }}</span>
                    </td>
                    <td class="text-right align-middle">
                        <!-- <a href="#" class="btn btn-danger font-weight-bolder font-size-sm">
                            Remove
                        </a> -->
                        € {{ formatNumbers(item.total) }}
                    </td>
                    <td>
                        <a @click="OpenOrderDetails(item.id, item.note)" href="javascript:;" 
                        v-b-tooltip.hover.top="$t('ECOMMERCE.OPEN_ORDER_DETAILS') + item.id" >
                          <span class="svg-icon svg-icon-lg svg-icon-primary">
                            <inline-svg src="media/svg/icons/Files/File-plus.svg" />
                          </span>
                        </a>

                    </td>
                </tr>
                </template>
            </tbody>
        </table>
      </div>
      <b-modal ref="my-modal" hide-footer :title="$t('ECOMMERCE.ORDER') + ' : ' + OrderId" size="lg">
        
        <div class="table-responsive">
          <table class="table table-head-custom table-vertical-center">
              <thead>
                  <tr>
                      <th style="min-width: 40px; max-width: 60px"></th>
                      <th style="min-width: 80px">{{ $t('ECOMMERCE.PRODUCTS') }}</th>
                      <th style="min-width: 50px; max-width: 90px" class="text-right">{{ $t('ECOMMERCE.QTY') }}</th>
                      <th style="min-width: 50px; max-width: 90px" class="text-right">{{ $t('ECOMMERCE.PU') }}</th>
                      <th style="min-width: 50px; max-width: 90px" class="text-right">{{ $t('TRANSLATOR.TOTAL') }}</th>
                  </tr>
              </thead>
              <tbody>
                <template v-for="(item, i) in OrderDetailsList">
                  <tr v-bind:key="i">
                      <td class="align-items-center font-weight-bolder">
                          <!--begin::Symbol-->
                          <div class="symbol symbol-40 flex-shrink-0 bg-light">
                            <!-- <img :src="item.url" @click="GoToProduct(`${item.category}/${item.code}`)" style="cursor: pointer;" /> -->
                              <div class="symbol-label" style="background-image: url('/metronic/theme/html/demo2/dist/assets/media/products/11.png')"></div>
                          </div>
                          <!--end::Symbol-->
                      </td>
                      <td class="align-middle">
                          <a @click="GoToProduct(`${item.category}/${item.code}`)" href="javascript:void(0)" class="text-dark text-hover-primary">{{ item.name }}<br>
                          <span>({{ item.category }}) Code : {{ item.code }}</span></a>
                      </td>
                      <td class="text-right">
                          {{ item.quantity }} x {{ item.minOrderQty }}
                      </td>
                      <td class="text-right align-middle">
                          <span class="mr-2 font-weight-bolder">€ {{ item.price }}</span>
                      </td>
                      <td class="text-right align-middle font-weight-bolder">
                          € {{ formatNumbers(item.price * (item.quantity * item.minOrderQty)) }}
                      </td>
                  </tr>
                  </template>
                  <tr>
                      <td colspan="3"></td>
                      <td class="font-weight-bolder text-right">{{ $t('ECOMMERCE.SUBTOTAL') }}</td>
                      <td class="font-weight-bolder text-right">€ {{  formatNumbers(getCartTotal) }}</td>
                  </tr>
                <tr>
                    <td colspan="7" class="border-0 ">
                      <div class="form-group mb-3">
                        <span class="form-text text-muted">{{ $t('ECOMMERCE.YOUR_NOTE') }} :</span>
                        <textarea ref="note" class="form-control form-control-lg form-control-solid" type="text"
                          v-model="note" rows="2"
                          :placeholder="$t('TRANSLATOR.ADD_EXTRA_NOTE_HERE')"
                          disabled />
                      </div>
                    </td>
                </tr>
              </tbody>
          </table>
        </div>
        <b-button class="mt-3 ml-3" variant="outline-primary" @click="CloseOrderDetails">{{ $t('ECOMMERCE.CLOSE') }}</b-button>
        <b-button class="mt-3 ml-3" variant="outline-danger" @click="CloseOrderDetails">{{ $t('ECOMMERCE.PRINT_PDF') }}</b-button>
      </b-modal>
    </div>
    <!-- IF NO ORDERS -->
    <div v-if="this.list.length < 1" class="scroll scroll-push">
        <div class="d-flex align-items-center justify-content-between p-8">
          <div class="d-flex flex-column mr-2">
            <span class="text-muted">
              {{ $t('ECOMMERCE.NO_ORDERS_FOUND_PLACE_FIRST_ORDER') }} <a href='/#/shop'>{{ $t('ECOMMERCE.SHOP_NOW') }}</a>
            </span>
          </div>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from 'axios';
import { LOGOUT } from "@/core/services/store/auth.module";

export default {
  name: "home",
  components: {
    // KTWidget2,
  },  
   data() {
     return {
        loading: false,
        OrderId: null,
        note: null,
        list: [],
        OrderDetailsList: [],
      }
    },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Orders" }]);
    this.loading = true;
    axios.get('/shop/getorders').then(response => {
        // console.log(response.data);
        this.list = response.data;
        this.loading = false;
      })
      .catch(err => {
          this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
        throw err
        })
  },
  computed:{
    getCartTotal() {
      const total = this.OrderDetailsList.reduce((sum, item) => {
        sum += item.price * (item.quantity * item.minOrderQty);
        return sum;
      }, 0);
      return Number((total).toFixed(2));
    },
  },
  methods: {
    formatNumbers: function(value) {
      return Number(value).toLocaleString('nl-NL', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });
    },
    GoToProduct(url){
      this.$router.push({ path: "/shop/" + url });
    },
    OpenOrderDetails(OrderId, note) {
      this.loading = true;
      this.$refs['my-modal'].show()
      axios.get("/shop/getorder/OrderId="+ OrderId).then(response => {
          this.OrderDetailsList = response.data;
          this.loading = false;
          this.OrderId = OrderId;
          this.note = note;
        })
        .catch(err => {
          this.loading = false;
          throw err
          })
    },
    CloseOrderDetails() {
      this.$refs['my-modal'].hide();
      this.OrderDetailsList = [];
    },
  }
};
</script>
